import {
    Dialog,
    Button,
    useStyles,
    FilterContentLayout,
    Grid,
    Caption,
    pxToRem,
    pxArrayToRem,
    Checkbox,
    useTheme,
} from '@archipro-design/aria';
import { CloseLine, Filter } from '@archipro-design/icons';
import React from 'react';
import * as S from './VideoSort.style';

import { SORT_OPTIONS } from '@modules/professional/component/video-tab/util';

import type { VideoSortProps } from './VideoSort';
import { Link, useLocation } from 'react-router';

const VideoSortMobile: React.FC<VideoSortProps> = (props) => {
    const { css } = useStyles();
    const [open, setOpen] = React.useState(false);

    return (
        <Dialog
            open={open}
            onOpen={() => setOpen(true)}
            onCancel={() => setOpen(false)}
            content={
                <VideoSortContent {...props} onClose={() => setOpen(false)} />
            }
            trigger={
                <Button
                    iconBefore={<Filter aria-label={'filter'} />}
                    size={14}
                    transparent={true}
                    variables={() => ({
                        buttonPadding: pxToRem(10),
                    })}
                    className={css(S.FilterToggleMobile)}
                >
                    Sort by
                </Button>
            }
            design={{
                minHeight: `100%`,
            }}
            variables={{
                rootBorderRadius: 0,
                rootWidth: '100%',
                rootPadding: 0,
                rootMaxWidth: `100%`,
                rootMaxHeight: `100%`,
                contentMargin: `0`,
            }}
            className={css(S.VideoSortMobile)}
        />
    );
};

export default VideoSortMobile;

const VideoSortContent: React.FC<VideoSortProps & { onClose: () => void }> = ({
    initialSort,
    itemCount,
    onClose,
}) => {
    const theme = useTheme();
    const { css } = useStyles();
    const [param, setParam] = React.useState(SORT_OPTIONS[initialSort]?.param);

    const location = useLocation();
    const sortParams = new URLSearchParams({
        page: '1',
        ...(param && { sortBy: param.toString() }),
    });

    return (
        <FilterContentLayout
            onClose={onClose}
            title="Sort by"
            submitButton={{
                children: `VIEW ${itemCount} RESULT${
                    itemCount === 1 ? '' : 'S'
                }`,
                as: Link,
                to: `${location.pathname}?${sortParams.toString()}`,
                onClick: () => onClose(),
                color: 'dark',
            }}
            closeButton={{
                size: 24,
                color: 'dark',
                transparent: true,
                variables: {
                    buttonPadding: 0,
                    iconPadding: 0,
                },
                icon: <CloseLine />,
            }}
            headerAction={{
                children: 'Clear all',
                onClick: () => {
                    setParam(SORT_OPTIONS[initialSort]?.param);
                },
                color: 'dark',
                size: 14,
            }}
            content={
                <Grid columns={'100%'} className={css(S.FilterContentWrap)}>
                    <div>
                        <Caption
                            variant="03"
                            design={{
                                marginBottom: pxToRem(8),
                                padding: pxArrayToRem([2, 0]),
                            }}
                        >{`SORT BY`}</Caption>
                        {SORT_OPTIONS.map((s) => {
                            return (
                                <Checkbox
                                    key={s.param}
                                    checked={s.param === param}
                                    onChange={() => setParam(s.param)}
                                    indicator={{
                                        kind: 'radio',
                                        indicator: {
                                            variables: {
                                                border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
                                                size: pxToRem(14),
                                            },
                                        },
                                    }}
                                    label={{
                                        children: s.item,
                                        variables: {
                                            fontSize: pxToRem(16),
                                            letterSpacing: 'normal',
                                        },
                                    }}
                                    variables={{
                                        labelLineHeight: pxToRem(40),
                                        radioIndicatorLabelGap: pxToRem(6),
                                        radioIndicatorLabelCheckedGap:
                                            pxToRem(6),
                                    }}
                                />
                            );
                        })}
                    </div>
                </Grid>
            }
        />
    );
};
